import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.assign";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? Object(arguments[i]) : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import classNames from 'classnames';
import Box from "../Box";
import FormBlock from "./FormBlock";
import FormContext, { defaultFormContextProps } from "./FormContext";
import { NegativeNotice } from "../Notice";

var FormLayout = function FormLayout(props) {
  var _defaultFormContextPr = _objectSpread({}, defaultFormContextProps, props),
      _defaultFormContextPr2 = _defaultFormContextPr.background,
      background = _defaultFormContextPr2 === void 0 ? 'offset' : _defaultFormContextPr2,
      children = _defaultFormContextPr.children,
      className = _defaultFormContextPr.className,
      _defaultFormContextPr3 = _defaultFormContextPr.divider,
      divider = _defaultFormContextPr3 === void 0 ? true : _defaultFormContextPr3,
      error = _defaultFormContextPr.error,
      layout = _defaultFormContextPr.layout,
      size = _defaultFormContextPr.size,
      remaining = _objectWithoutProperties(_defaultFormContextPr, ["background", "children", "className", "divider", "error", "layout", "size"]);

  var classes = classNames('FormLayout', className);
  var dividerValue = divider ? {
    side: 'bottom'
  } : null;
  var last = React.Children.count(children) - 1;
  var items = React.Children.map(children, function (child, i) {
    var isLast = child && child.type && child.type === FormBlock && i === last;

    if (isLast) {
      return /*#__PURE__*/React.cloneElement(child, {
        divider: false
      });
    }

    return child;
  });
  var value = React.useMemo(function () {
    return {
      layout: layout,
      size: size
    };
  }, [layout, size]);
  return /*#__PURE__*/React.createElement(FormContext.Provider, {
    value: value
  }, /*#__PURE__*/React.createElement(Box, _extends({}, remaining, {
    className: classes,
    background: background,
    divider: dividerValue
  }), error && /*#__PURE__*/React.createElement(NegativeNotice, {
    role: "alert",
    title: error
  }), /*#__PURE__*/React.createElement(Box, null, items)));
};

export default FormLayout;